const convertToArray = nodeList => Array.prototype.slice.call(nodeList);
export default convertToArray;



// WEBPACK FOOTER //
// ./src/js/module/convertToArray.js